module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"paid_online":"Paid online","manual_bank_transfer":"Manual bank transfer","pay_at_shop":"Pay at shop"},"id":{"paid_online":"Pembayaran Online","manual_bank_transfer":"Pembayaran manual transfer","pay_at_shop":"Bayar di toko"}}')
  delete Component.options._Ctor
}
